import React from "react"
import PropTypes from "prop-types"
import { Container, Metric, Title, StatLink, StyledP } from "./styles"
import { P } from "../typography"

const RatingStat = ({ rating, outOf, title, link }) => (
  <Container>
    <Metric>
      <P variant="secondary" marginless bold size="large">
        {!link && rating}
        {link && <StatLink to={link}>{rating}</StatLink>}
      </P>
      {outOf && (
        <P variant="secondary" marginless>
          /{outOf}
        </P>
      )}
    </Metric>

    <Title>
      {title && (
        <StyledP variant="secondary" marginless align="center" size="large">
          {title}
        </StyledP>
      )}
    </Title>
  </Container>
)

RatingStat.propTypes = {
  rating: PropTypes.number.isRequired,
  outOf: PropTypes.number.isRequired,
  title: PropTypes.string
}

RatingStat.defaultProps = {
  rating: 0,
  outOf: 10,
  title: null
}

export default RatingStat
